
//Header.js

import React, { useContext, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { lightTheme, darkTheme } from '../themes'; // Importe os temas
import { AuthContext } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Paper } from '@mui/material';
import logo from './Alfatek.png';
import '../App.css';
//import './Header.css'; // Arquivo CSS específico para o cabeçalho


function Header() {
  const { auth, setAuth } = useContext(AuthContext);
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate(); // Definindo o useNavigate

  const [anchorElVendas, setanchorElVendas] = useState(null);
  const [anchorElCompras, setanchorElCompras] = useState(null);
  const [anchorElFinanceiro, setanchorElFinanceiro] = useState(null);
  
  const [nomecompleto, setNomeCompleto] = useState('');
  const [selectedEmpresa, setSelectedEmpresa] = useState('');

  useEffect(() => {
    setNomeCompleto(localStorage.getItem('name'));
    setSelectedEmpresa(localStorage.getItem('selectedEmpresa'));

    const handleStorageChange = (event) => {
      if (event.key === 'selectedEmpresa') {
        setSelectedEmpresa(event.newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);

    const handleEmpresaSelecionada = () => {
      setSelectedEmpresa(localStorage.getItem('selectedEmpresa'));
    };

    window.addEventListener('empresaSelecionada', handleEmpresaSelecionada);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('empresaSelecionada', handleEmpresaSelecionada);
    };
  }, []);

const handleClickVendas = (event) => {
  setanchorElVendas(event.currentTarget);
};
const handleCloseVendas = () => {
  setanchorElVendas(null);
};

const handleClickCompras = (event) => {
  setanchorElCompras(event.currentTarget);
};
const handleCloseCompras = () => {
  setanchorElCompras(null);
};


const handleClickFinanceiro = (event) => {
  setanchorElFinanceiro(event.currentTarget);
};
const handleCloseFinanceiro = () => {
  setanchorElFinanceiro(null);
};

const handleLogout = () => {
  // Limpa o localStorage
  localStorage.clear();

// Atualiza o estado de autenticação
  setAuth(false);

  // Redireciona para a página de login
  navigate('/login');
  
};
 

    // Redirecionar para o Google após o logout
    //window.location.href = 'https://www.google.com';


  return (
    <div style={{ textAlign: 'center', ...theme }}> {/* Adicione os estilos do tema aqui */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div className="logoheader">
              <img src={logo} alt="Alfatek Logo" style={{ width: '50px', height: 'auto', marginTop: '0px', marginLeft: '20px', marginRight: '20px' }} />
            </div>
            <h3 style={{ marginTop: '0px', marginBottom: '0', color: "#cf1508" }}>Alfatek Sistemas</h3>
        </div>
        
        {selectedEmpresa && (
          <h6 style={{ marginTop: '0px', marginBottom: '0', color: 'inherit', marginRight: "50px" }}>
            Empresa: {selectedEmpresa}
          </h6>
        )}

        <h6 style={{ marginTop: '0px', marginBottom: '0', color: 'inherit', marginRight: "100px" }}>
            {auth ? `Bom trabalho, ${nomecompleto}` : ''}
        </h6>

      </div>
      
    <nav style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap", // Permite quebra de linha
    width: "100%",
    maxWidth: "100%",
    margin: "0",
    padding: "10px 0",
    color: theme === lightTheme ?  lightTheme.color : darkTheme.color ,
    }}>
        
      <Link to="/home" className='btn-menu' style={{ marginRight: "10px", padding: '3px 5px', color: 'inherit', textDecoration: 'none' }}>Empresas</Link>

      <button type="button" className='btn-menu' onClick={handleClickVendas} style={{ marginRight: "10px", padding: '3px 5px', color: 'inherit' }}>Vendas</button>

      <button type="button" className='btn-menu'  onClick={handleClickCompras}style={{ marginRight: "10px", padding: '3px 5px', color: 'inherit' }}>Compras</button>
        
      <button type="button" className='btn-menu'  onClick={handleClickFinanceiro}style={{ marginRight: "10px", padding: '3px 5px', color: 'inherit' }}>Financeiro</button>

      <Link to="/gerencial" className='btn-menu' style={{ marginRight: "10px", padding: '3px 5px', color: 'inherit', textDecoration: 'none' }} translate="no">Gerencial</Link>
         
      <Link to="/producao" className='btn-menu' style={{ marginRight: "10px", padding: '3px 5px', color: 'inherit', textDecoration: 'none' }}>Produção</Link>

      <Link to="/relatorios" className='btn-menu' style={{ marginRight: "10px", padding: '3px 5px', color: 'inherit', textDecoration: 'none' }}>Relatórios</Link>


<Menu
  anchorEl={anchorElVendas}
  open={Boolean(anchorElVendas)}
  onClose={handleCloseVendas}>
  <Paper style={{ backgroundColor: '#3ca9e2' }}> 
            
    <MenuItem onClick={handleCloseVendas}>
      <Link to="/clientes" style={{ textDecoration: 'none', color: 'inherit' }}>Clientes</Link>
    </MenuItem>
            
    <MenuItem onClick={handleCloseVendas}>
      <Link to="/vendas" style={{ textDecoration: 'none', color: 'inherit' }}>Vendas</Link>
    </MenuItem>

    <MenuItem onClick={handleCloseVendas}>
      <Link to="/produtos" style={{ textDecoration: 'none', color: 'inherit' }}>Produtos</Link>
    </MenuItem>
                           
    <MenuItem onClick={handleCloseVendas}>
      <Link to="/areceber" style={{ textDecoration: 'none', color: 'inherit' }} translate="no">A Receber</Link>
    </MenuItem>

    <MenuItem onClick={handleCloseVendas}>
      <a href="https://amei.sebrae.com.br/auth/realms/externo/protocol/openid-connect/auth?client_id=emissor-nfe-frontend&redirect_uri=https%3A%2F%2Femissornfe.sebrae.com.br%2F&state=3e67ca49-22c2-4e8f-8e58-335c65748c49&response_mode=fragment&response_type=code&scope=openid&nonce=4fa8e9a6-0700-4a53-bf92-27ff79eaff34" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
        Nota Fiscal
      </a>
    </MenuItem>            

  </Paper>
</Menu>


<Menu
  anchorEl={anchorElCompras}
  open={Boolean(anchorElCompras)}
  onClose={handleCloseCompras}>
  <Paper style={{ backgroundColor: '#3ca9e2' }}> 
            
    <MenuItem onClick={handleCloseCompras}>
      <Link to="/fornecedores" style={{ textDecoration: 'none', color: 'inherit' }}>Fornecedores</Link>
    </MenuItem>
    <MenuItem onClick={handleCloseCompras}>
      <Link to="/compras" style={{ textDecoration: 'none', color: 'inherit' }}>Compras</Link>
    </MenuItem>
            
    <MenuItem onClick={handleCloseCompras}>
      <Link to="/materiais" style={{ textDecoration: 'none', color: 'inherit' }}>Materiais</Link>
    </MenuItem>
            
    <MenuItem onClick={handleCloseCompras}>
              <Link to="/apagar" style={{ textDecoration: 'none', color: 'inherit' }} translate="no">A Pagar</Link>
    </MenuItem>


    <MenuItem onClick={handleCloseCompras}>
      <Link to="/estoque" style={{ textDecoration: 'none', color: 'inherit' }}>Estoque</Link>
    </MenuItem>
             
  </Paper>
</Menu>
 

<Menu
  anchorEl={anchorElFinanceiro}
  open={Boolean(anchorElFinanceiro)}
  onClose={handleCloseFinanceiro}>
  <Paper style={{ backgroundColor: '#3ca9e2' }}> 
            
    <MenuItem onClick={handleCloseFinanceiro}>
      <Link to="/apagar" style={{ textDecoration: 'none', color: 'inherit' }} translate="no">Contas a Pagar</Link>
    </MenuItem>
    <MenuItem onClick={handleCloseFinanceiro}>
      <Link to="/areceber" style={{ textDecoration: 'none', color: 'inherit' }} translate="no">Contas a Receber</Link>
    </MenuItem>
    <MenuItem onClick={handleCloseFinanceiro}>
      <Link to="/bancos" style={{ textDecoration: 'none', color: 'inherit' }}>Controle Bancário</Link>
    </MenuItem>
             
  </Paper>
</Menu>
        

      <button type="button" className='btn-tema'
      onClick={toggleTheme}style={{ marginRight: "10px", padding: '3px 5px',  color: 'inherit' }}>Tema</button>

      <button type="button" className='btn-sair'
      onClick={handleLogout}style={{ marginRight: "0px", padding: '3px 10px', color: 'inherit' }}>Sair</button>

      </nav>      
      <hr style={{ marginTop: '0px', marginBottom: '0', color: "#cf1508" }}/>
      </div>  
    
  );
}

export default Header;
